import type {
  PublicTrip,
  PublicTripV4
} from "@busbud/core-types/dist/lib/poll-service/api";

export function isRoundtrip(trip: PublicTrip | PublicTripV4): boolean {
  return trip.trip_legs.length === 2;
}
